/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_RefreshedInputs */

const cs_tasks_protocol_refreshed = /** @type {(inputs: Tasks_Protocol_RefreshedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav podpisu obnoven`)
};

const en_tasks_protocol_refreshed = /** @type {(inputs: Tasks_Protocol_RefreshedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing status refreshed`)
};

/**
* | output |
* | --- |
* | "Signing status refreshed" |
*
* @param {Tasks_Protocol_RefreshedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_refreshed = /** @type {((inputs?: Tasks_Protocol_RefreshedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_RefreshedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_refreshed(inputs)
	return cs_tasks_protocol_refreshed(inputs)
});